import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";
  const bgClass = scrolled
    ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
    : isHome
      ? "bg-transparent"
      : "bg-background-50/95 backdrop-blur-md border-b border-background-200/70";

  const textClass = scrolled || !isHome ? "text-foreground-950" : "text-white";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${bgClass}`}
      aria-label="主导航"
    >
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 md:h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span
              className={`text-xl md:text-2xl font-bold tracking-tight transition-colors duration-300 ${textClass}`}
              style={{ fontFamily: "var(--font-heading)" }}
            >
              <span className="text-primary-500">91</span>吃瓜
            </span>
          </Link>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            <Link
              to="/"
              className={`text-sm font-medium hover:text-primary-500 transition-colors whitespace-nowrap ${textClass}`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium hover:text-primary-500 transition-colors whitespace-nowrap ${textClass}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium hover:text-primary-500 transition-colors whitespace-nowrap ${textClass}`}
            >
              关于我们
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center ${textClass}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
            aria-expanded={mobileOpen}
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/70">
          <div className="px-4 py-4 space-y-1">
            <Link
              to="/"
              className="block py-2.5 px-3 text-sm font-medium text-foreground-950 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="block py-2.5 px-3 text-sm font-medium text-foreground-950 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="block py-2.5 px-3 text-sm font-medium text-foreground-950 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}